import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  message: {
    color: '#32383b',
    fontSize: '13px',
  },

  reasonType: {
    color: '#30383c',
    fontSize: '16px',
  },

  requirementDetailsContainer: {
    marginTop: theme.spacing(1.2),
  },

  title: {
    color: theme.palette.text.primary,
    fontSize: '23px',
    fontWeight: 'bold',
  },
})
